import React, { useEffect, useState } from 'react';
import styles from './DataAiNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { Agent, knowledgeBase, variableManagement } from 'hooks/endpoints';
import DataAiModal from './dataAi-Modal/DataAiModal';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';

const DataAiNode = ({ id, selected, onNodesDelete }) => {
  const { workflowData } = useWorkflowContext();
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const dataAI = node?.dataAI;
  const api = node?.dataAI?.endpoints;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(node?.is_Error || false);
  const [apis, setApis] = useState([]);

  const { data: connections, isFetching: isLoadingConnections } = useFetch(
    ['connectionApis', workflowData?.botId],
    Agent.getApis(dataAI?.agentId)
  );

  const { data, isFetching } = useFetch(
    ['variableManagement'],
    variableManagement.get,
    { enabled: true },
    { pageSize: 1000, pageNumber: 1 }
  );
  useEffect(() => {
    if (dataAI) {
      if (
        !dataAI?.outputVariableId ||
        !dataAI?.question ||
        !dataAI?.responseThemeId
      ) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [
    dataAI,
    dataAI?.outputVariableId,
    dataAI?.question,
    dataAI?.responseThemeId,
  ]);

  useEffect(() => {
    if (api?.length > 0) {
      const selectedMaterials = api.map((materialId) =>
        connections?.data?.find((i) => i.id === materialId.agentConnectionId)
      );
      setApis(selectedMaterials);
    } else {
      setApis([]);
    }
  }, [api, connections]);

  return (
    <>
      <NodeContainer
        title='Data AI'
        id={id}
        onClick={() => setIsModalOpen(true)}
        name={node?.title ?? 'Data AI'}
        backgroundColor={node?.color}
        selected={selected}
        onNodesDelete={onNodesDelete}
        node={node}
        isError={isError}
      >
        <Handle
          type='target'
          position={Position.Left}
          className='custom-handle'
        />

        <div className={styles['questions-cont']}>
          <div className={styles.svg}>
            <SvgWithBranding
              type='node-ai'
              color='#787878'
              // className={styles.deleteIcon}
            />
            {!dataAI?.question || dataAI?.question === '<p><br></p>' ? (
              <span className={styles.placeholder}>Enter Question</span>
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: dataAI.question,
                }}
              ></div>
            )}
          </div>
          {api && apis?.length > 0 && (
            <div className={styles.folders}>
              {apis && apis?.length > 0 ? (
                apis?.map((item, index) => {
                  return (
                    <div key={index} className={styles.svg}>
                      <SvgWithBranding type='connect' color='#787878' />
                      <p className={styles.label}>{item?.apiName}</p>
                    </div>
                  );
                })
              ) : (
                <div className={styles.svg}></div>
              )}
            </div>
          )}
          {!dataAI?.outputVariableId ? null : (
            <div className={styles.svg}>
              <p className={styles.type}>
                {'{'}
                {
                  data?.data?.items?.find(
                    (i) => i.variableId === dataAI?.outputVariableId
                  )?.variableName
                }
                {'}'}
              </p>
            </div>
          )}
        </div>

        <Handle
          type='source'
          position={Position.Right}
          className='custom-handle'
        />
      </NodeContainer>

      <DataAiModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={id}
        title='Data AI'
        isError={isError}
      />
    </>
  );
};

export default DataAiNode;
